import { L1Portal } from "@turnstile-portal/turnstile.js";
import { erc20Abi, getContract, type Address } from "viem";
import { getL1ClientAsync } from "../wagmi";

export async function depositRequest(
  l1PortalAddr: Address,
  tokenAddr: Address,
  l2RecipientAddr: Address,
  amount: bigint,
  startWaiting?: () => void,
) {
  const l1Client = await getL1ClientAsync();

  const token = getContract({
    address: tokenAddr,
    abi: erc20Abi,
    client: l1Client.getWalletClient()
  });

  const approveTx = await token.write.approve([l1PortalAddr, amount]);
  const approveReceipt = await l1Client.getPublicClient().waitForTransactionReceipt({ hash: approveTx });
  if (!approveReceipt) {
    throw new Error("Failed to get receipt for approve transaction");
  }
  if (approveReceipt.status !== "success") {
    throw new Error("Approve transaction failed");
  }

  // Deposit the tokens to the L2 network
  const portal = new L1Portal(l1PortalAddr, l1Client);
  const depositResult = await portal.deposit(tokenAddr, l2RecipientAddr, amount);
  // depositResult contains txHash, messageHash, messageIndex

  if (startWaiting) {
    startWaiting();
    if (import.meta.env.MODE === "development") {
      await new Promise((resolve) => setTimeout(resolve, 10000));
    }
  }

  console.log(`L1 Deposit successful. Transaction hash: ${depositResult.txHash}`);

  // The new API returns simpler response with txHash, messageHash, messageIndex
  const { txHash, messageHash: hash, messageIndex: index, l2BlockNumber } = depositResult;
  console.log(`Deposit: hash: ${hash}, index: ${index})`);

  return { txHash, hash, l2BlockNumber, index };
}
